<script lang="ts">
	import { FormsPage } from '#lib/websites/forms/pages/FormsPage/index.js';
</script>

<FormsPage />
